import { QueryResource, QueryResourcesInfinite } from 'datx-jsonapi-react';

import { EventChatChannel } from '@/resources/EventChatChannel';

export const queryAllEventChatChannels = (
  eventId: string,
  query: string,
  pageSize = 10
): QueryResourcesInfinite<EventChatChannel> => {
  return (pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData?.links?.next) {
      return null;
    }
    const pageNumber = pageIndex + 1;

    return [
      EventChatChannel.type,
      {
        filter: {
          event_id: eventId,
          searchable_attribute: ['first_name', 'last_name', 'institutions.name'],
          ...(query && { query }),
        },
        sort: '-last_activity_at',
        include: ['event_chat_channel_participants.user.main_profile'],
        params: [
          {
            key: 'page[size]',
            value: pageSize.toString(),
          },
          {
            key: 'page[number]',
            value: pageNumber.toString(),
          },
        ],
      },
    ];
  };
};

export const queryChatChannelOfUser = (userId: string, eventId?: string): QueryResource<EventChatChannel> => {
  if (!userId) return null;
  return [
    EventChatChannel,
    userId,
    {
      filter: {
        event_id: eventId,
      },
      params: [
        {
          key: 'find_by',
          value: 'participant_id',
        },
      ],
    },
  ];
};
